import { render, staticRenderFns } from "./FacilitiesCount.vue?vue&type=template&id=16a48280"
import script from "./FacilitiesCount.vue?vue&type=script&lang=js"
export * from "./FacilitiesCount.vue?vue&type=script&lang=js"
import style0 from "./FacilitiesCount.vue?vue&type=style&index=0&id=16a48280&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports